import request, { get, post } from '@tools/request';
import _ from 'lodash';

// 登录
export function login(param) {
  const apiPath = '/ucenter/aggregate-login';
  let fingerToken = '';
  if (_.isFunction(window.initDeviceFinger)) {
    const deviceFinger = new window.initDeviceFinger(); // eslint-disable-line
    fingerToken = deviceFinger.gettoken(apiPath, request.defaults.baseURL);
  }
  return post(`/ucenter/aggregate-login?device-token=${fingerToken}`, param, true);
}
// 登录校验
export function validate(param) {
  const apiPath = '/ucenter/login-validation';
  let fingerToken = '';
  if (_.isFunction(window.initDeviceFinger)) {
    const deviceFinger = new window.initDeviceFinger(); // eslint-disable-line
    fingerToken = deviceFinger.gettoken(apiPath, request.defaults.baseURL);
  }

  return post(`${apiPath}?device-token=${fingerToken}`, param, true);
}
// 发送手机验证码
export function sendSms(param) {
  return get('ucenter/send-login-sms', param);
}
// 获取区号列表
export function getCountryCodes() {
  return get('ucenter/country-codes');
}
// 检查账号是否重复
export function validateAccount(params) {
  return get('ucenter/phone-number-validate', params);
}

// web查询扫码登录token状态
export function checkLoginStatus({ qrToken }) {
  return get('ucenter/qr-token/status', { qrToken });
}

// web生成扫码登录token
export function getToken(params) {
  return post('ucenter/qr-token/create', params, true);
}

// 登录后的两步验证或手机验证码验证
export function validationLogin({ token, validationType }) {
  return post('ucenter/login-validation', { token, validationType }, true);
}

// 重新发送登录授权邮件
export function resendMail(params = {}) {
  return post('/ucenter/login-verify/resend', params, true);
}

// 查询授权结果
export function getMailVerifyResult(params = {}) {
  return get('/ucenter/login-verify/query', params);
}
